import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'rye',
  templateUrl: './rye.component.html',
  styleUrls: ['./rye.component.scss']
})
export class RyeComponent {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

}
